module.exports = __webpack_public_path__ + "static/media/bytt-nn-8.8bdca9e0.mp3";